import { render } from "./ContactoPage.vue?vue&type=template&id=662506f1&scoped=true"
import script from "./ContactoPage.vue?vue&type=script&lang=js"
export * from "./ContactoPage.vue?vue&type=script&lang=js"

import "./ContactoPage.vue?vue&type=style&index=0&id=662506f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662506f1"]])

export default __exports__